export default "__VITE_ASSET__DRAX_a6T__"